<template>
  <div>
    <modal
      name="offer-modal-archive-edit"
      :resizable="true"
      :height="'auto'"
      :width="'95%'"
      :scrollable="true"
    >
      <!-- Nagłówek modalu -->
      <div class="modal-header-custom">
      <div class="header-content">
        <h3 class="modal-title">📄 Edycja oferty {{ offer.offerNumber }}</h3>
        <p class="modal-subtitle">Modyfikuj szczegóły oferty archiwalnej</p>
      </div>
      <button class="btn-close-modal" @click="$emit('closeModalEdit')">
        ✕
      </button>
    </div>

    <!-- Zawartość modalu -->
    <div class="modal-content-custom">
      <!-- Sekcja podstawowych informacji -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">📋</span>
          Informacje podstawowe
        </h5>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Kontrahent *</label>
            <input
              v-model="offer.contractor"
              type="text"
              class="form-input"
              placeholder="Nazwa kontrahenta"
            />
          </div>
        </div>
  <div class="form-group">
          <label class="form-label">Nagłówek oferty</label>
          <textarea
            v-model="offer.header2"
            class="form-textarea"
            rows="2"
            placeholder="Główny nagłówek oferty"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Nagłówek tabeli</label>
            <input
              v-model="offer.offerHeader"
              type="text"
              class="form-input"
              placeholder="Nagłówek tabeli oferty"
            />
          </div>
        </div>

      

        <div class="form-group">
          <label class="form-label">Szczegóły oferty</label>
          <textarea
            v-model="offer.subheader"
            class="form-textarea"
            rows="3"
            placeholder="Dodatkowe szczegóły i informacje"
          ></textarea>
        </div>
      </div>

      <!-- Sekcja pozycji oferty -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">📦</span>
          Pozycje oferty
        </h5>

        <div class="table-container">
          <table class="offer-table">
            <thead>
              <tr>
                <th>Przedmiot</th>
                <th>Jednostka</th>
                <th>Ilość</th>
                <th>Cena netto</th>
                <th>Wartość netto</th>
                <th>Wartość brutto</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in offer.offer" :key="index" class="item-row">
                <td>
                  <input
                    v-model="item.name"
                    type="text"
                    class="table-input"
                    placeholder="Nazwa przedmiotu"
                  />
                </td>
                <td>
                  <input
                    v-model="item.measure"
                    type="text"
                    class="table-input"
                    placeholder="szt., m², m³..."
                  />
                </td>
                <td>
                  <input
                    v-model="item.amount"
                    type="number"
                    class="table-input"
                    placeholder="0"
                    step="0.01"
                  />
                </td>
                <td>
                  <input
                    v-model="item.price"
                    type="number"
                    class="table-input"
                    placeholder="0.00"
                    step="0.01"
                  />
                </td>
                <td>
                  <span class="calculated-value" v-if="item.price">
                    {{ (item.price * item.amount).toFixed(2) }} zł
                  </span>
                  <span v-else class="empty-value">-</span>
                </td>
                <td>
                  <span class="calculated-value" v-if="item.price">
                    {{ (item.price * item.amount * offer.vat).toFixed(2) }} zł
                  </span>
                  <span v-else class="empty-value">-</span>
                </td>
                <td>
                  <button class="btn-delete-item" @click="deleteItem(index)" title="Usuń pozycję">
                    🗑️
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="summary-row">
                <td><strong>Suma</strong></td>
                <td>
                  <select v-model="offer.vat" class="vat-select">
                    <option value="0">VAT</option>
                    <option value="1.08">8%</option>
                    <option value="1.23">23%</option>
                  </select>
                </td>
                <td></td>
                <td></td>
                <td><strong class="total-value">{{ totalPriceNetto }} zł</strong></td>
                <td><strong class="total-value">{{ totalPriceBrutto }} zł</strong></td>
                <td></td>
              </tr>
            </tfoot>
          </table>

          <button class="btn-add-item" @click="addElement()">
            <span class="plus-icon">+</span>
            Dodaj pozycję
          </button>
        </div>
      </div>

      <!-- Sekcja załączników -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">📷</span>
          Załączniki
        </h5>

        <div class="image-upload-section">
          <label for="customInputFile" class="upload-label">
            <div class="upload-icon">
              <svg width="32" height="32" viewBox="0 0 16 16" fill="currentColor">
                <path fill-rule="evenodd" d="M15 12V6a1 1 0 0 0-1-1h-1.172a3 3 0 0 1-2.12-.879l-.83-.828A1 1 0 0 0 9.173 3H6.828a1 1 0 0 0-.707.293l-.828.828A3 3 0 0 1 3.172 5H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/>
                <path fill-rule="evenodd" d="M8 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                <path d="M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
              </svg>
            </div>
            <div class="upload-text">
              <span class="upload-title">Dodaj zdjęcie</span>
              <span class="upload-subtitle">Kliknij aby wybrać plik</span>
            </div>
          </label>
          <input
            id="customInputFile"
            type="file"
            accept="image/*"
            @change="uploadImage"
            style="display: none;"
          />

          <div v-if="offer.imageUrl" class="image-preview">
            <img :src="offer.imageUrl" alt="Załącznik oferty" />
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Uwagi do oferty</label>
          <textarea
            v-model="offer.notice"
            class="form-textarea"
            rows="4"
            placeholder="Dodatkowe uwagi, komentarze lub informacje..."
          ></textarea>
        </div>
      </div>
    </div>

    <!-- Fixed footer -->
    <div class="modal-footer-custom">
      <div class="footer-left">
        <button class="btn-delete" @click="deleteOffer()">
          <span class="delete-icon">🗑️</span>
          Usuń ofertę
        </button>
      </div>
      
      <!-- Toast w footerze -->
      <div class="footer-center">
        <transition name="fade">
          <div v-if="showToast" :class="['footer-toast', toastType === 'success' ? 'footer-toast-success' : 'footer-toast-error']">
            {{ toastMessage }}
          </div>
        </transition>
      </div>
      
      <div class="footer-right">
        <button class="btn-cancel" @click="$emit('closeModalEdit')">
          ← Anuluj
        </button>
        <button class="btn-submit" @click="updateOffer()">
          <span class="submit-icon">✓</span>
          Zapisz zmiany
        </button>
      </div>
    </div>
  </modal>
  </div>
</template>
<script>
export default {
  props: ["offer"],
  data() {
    return {
      imageURL: "",
      date: new Date(),
      showToast: false,
      toastMessage: "",
      toastType: "success"
    };
  },
  computed: {
    totalPriceNetto() {
      let priceNetto = 0;
      this.offer.offer.forEach((item) => {
        if (item.price) {
          priceNetto += item.price * item.amount;
        }
      });
      return priceNetto.toFixed(2);
    },
    totalPriceBrutto() {
      let priceBrutto = 0;
      this.offer.offer.forEach((item) => {
        if (item.price) {
          priceBrutto += item.price * item.amount * this.offer.vat;
        }
      });
      return priceBrutto.toFixed(2);
    },
  },
  methods: {
    showSuccessToast() {
      console.log('Wyświetlam toast sukcesu');
      this.toastMessage = '✓ Oferta została zaktualizowana!';
      this.toastType = 'success';
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },
    displayErrorToast(message) {
      console.log('Wyświetlam toast błędu:', message);
      // Sprawdź czy błąd dotyczy rozmiaru pliku
      if (message.includes("Request payload size exceeds the limit") || 
          message.includes("The value of property \"imageUrl\" is longer than")) {
        this.toastMessage = '✕ Rozmiar zdjęcia jest za duży';
      } else {
        this.toastMessage = '✕ ' + message;
      }
      this.toastType = 'error';
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 4000);
    },
    updateOffer() {
      console.log('updateOffer wywołane');
      if (!this.offer.contractor) {
        alert("Wprowadź nazwę kontrahenta");
        return;
      }

      console.log('Rozpoczynam aktualizację oferty...');
      this.$store
        .dispatch("updateOffer", {
          id: this.offer.id,
          offer: this.offer.offer,
          vat: this.offer.vat,
          netto: parseFloat(this.totalPriceNetto),
          brutto: parseFloat(this.totalPriceBrutto),
          imageUrl: this.offer.imageUrl,
          offerHeader: this.offer.offerHeader,
          header: this.offer.header,
          notice: this.offer.notice,
          header2: this.offer.header2,
          subheader: this.offer.subheader,
          contractor: this.offer.contractor,
        })
        .then(() => {
          console.log('Oferta zaktualizowana pomyślnie');
          this.showSuccessToast();
          setTimeout(() => {
            this.$emit("closeModalEdit");
          }, 1000);
        })
        .catch((error) => {
          console.error("Błąd podczas aktualizacji oferty:", error);
          this.displayErrorToast(error.message);
        });
    },
    // total() {
    //   this.totalPriceNetto = 0;
    //   this.totalPriceBrutto = 0;
    //   this.offer.offer.forEach((item) => {
    //     console.log(item.price + " ->edit");
    //     if (item.price) {
    //       this.totalPriceNetto += item.price * item.amount;
    //       this.totalPriceBrutto += item.price * item.amount * this.offer.vat;
    //     }
    //   });
    // },
    addElement() {
      this.offer.offer.push({ name: "wpisz nazwę" });
    },
    deleteOffer() {
      if (confirm("Czy jesteś pewien ze chcesz usunąć ofertę?")) {
        this.$store.dispatch("deleteOffer", {
          id: this.offer.id,
        });
        this.$emit("closeModalEdit");
      }
    },
    deleteItem(index) {
      console.log(index);
      this.offer.offer.splice(index, 1);
    },

    uploadImage() {
      var img = document.getElementById("customInputFile").files[0];
      this.getBase(img, (response) => {
        this.offer.imageUrl = response;
      });
    },

    getBase(img, callback) {
      var reader = new FileReader();
      reader.onload = function (fileLoadedEvent) {
        var srcData = fileLoadedEvent.target.result;
        callback(srcData);
      };
      reader.readAsDataURL(img);
      //   console.log("outer", this.imageURL);
    },
  },
};
</script>

<style scoped>
/* MODAL STRUCTURE */
.v--modal-overlay {
  padding-top: 80px;
}

.modal-header-custom {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 28px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.header-content {
  flex: 1;
}

.modal-title {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-subtitle {
  margin: 8px 0 0 0;
  font-size: 14px;
  opacity: 0.95;
  font-weight: 500;
}

.btn-close-modal {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 300;
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* MODAL CONTENT */
.modal-content-custom {
  padding: 32px;
  padding-bottom: 120px;
  background: #f8f9fa;
  max-height: calc(100vh - 280px);
  overflow-y: auto;
}

/* SECTIONS */
.form-section {
  background: white;
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  position: relative;
}

.form-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px 0 0 16px;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 24px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 12px;
}

.section-icon {
  font-size: 24px;
}

/* FORM ELEMENTS */
.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input,
.form-textarea {
  padding: 14px 16px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 15px;
  color: #2c3e50;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
}

/* TABLE */
.table-container {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  overflow-x: auto;
}

.offer-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
  min-width: 900px;
}

.offer-table thead th {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 14px 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: none;
}

.offer-table thead th:first-child {
  border-radius: 10px 0 0 10px;
}

.offer-table thead th:last-child {
  border-radius: 0 10px 10px 0;
}

.offer-table tbody .item-row {
  background: white;
  transition: all 0.3s ease;
}

.offer-table tbody .item-row:hover {
  transform: scale(1.01);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.offer-table tbody td {
  padding: 12px;
  vertical-align: middle;
  border: none;
  background: white;
}

.offer-table tbody tr td:first-child {
  border-radius: 10px 0 0 10px;
}

.offer-table tbody tr td:last-child {
  border-radius: 0 10px 10px 0;
}

.table-input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.table-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.calculated-value {
  font-weight: 600;
  color: #667eea;
  font-size: 14px;
}

.empty-value {
  color: #adb5bd;
  font-style: italic;
}

.btn-delete-item {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
}

.btn-delete-item:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
}

/* TABLE FOOTER */
.offer-table tfoot .summary-row {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.offer-table tfoot td {
  padding: 16px 12px;
  border: none;
  font-size: 15px;
}

.offer-table tfoot tr td:first-child {
  border-radius: 10px 0 0 10px;
}

.offer-table tfoot tr td:last-child {
  border-radius: 0 10px 10px 0;
}

.vat-select {
  padding: 10px 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.vat-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.total-value {
  color: #667eea;
  font-size: 16px;
}

.btn-add-item {
  width: 100%;
  margin-top: 16px;
  padding: 14px 24px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-add-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

.plus-icon {
  font-size: 20px;
  font-weight: 700;
}

/* IMAGE UPLOAD */
.image-upload-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-label {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px dashed #dee2e6;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.upload-label:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
  color: white;
}

.upload-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 10px;
  color: #667eea;
  transition: all 0.3s ease;
}

.upload-label:hover .upload-icon {
  transform: scale(1.1);
  color: #764ba2;
}

.upload-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.upload-title {
  font-size: 15px;
  font-weight: 600;
  color: inherit;
}

.upload-subtitle {
  font-size: 13px;
  opacity: 0.8;
}

.image-preview {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.image-preview img {
  width: 100%;
  height: auto;
  display: block;
}

/* MODAL FOOTER */
.modal-footer-custom {
  background: white;
  padding: 20px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 2px solid #e9ecef;
  position: sticky;
  bottom: 50px;
  z-index: 100;
  box-shadow: 0 -4px 12px rgba(0,0,0,0.05);
}

.footer-left,
.footer-right {
  display: flex;
  gap: 12px;
  align-items: center;
}

.btn-submit,
.btn-cancel,
.btn-delete {
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-submit {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.btn-cancel {
  background: #e9ecef;
  color: #495057;
}

.btn-cancel:hover {
  background: #dee2e6;
  transform: translateY(-2px);
}

.btn-delete {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.btn-delete:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(220, 53, 69, 0.4);
}

.submit-icon,
.delete-icon {
  font-size: 18px;
}

/* FOOTER TOAST */
.footer-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-toast {
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-toast-success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}

.footer-toast-error {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .modal-header-custom {
    padding: 20px;
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .btn-close-modal {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .modal-content-custom {
    padding: 20px;
  }

  .form-section {
    padding: 20px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .table-container {
    padding: 12px;
  }

  .modal-footer-custom {
    flex-direction: column;
    gap: 12px;
    padding: 16px;
  }

  .footer-left,
  .footer-right {
    width: 100%;
    flex-direction: column;
  }

  .btn-submit,
  .btn-cancel,
  .btn-delete {
    width: 100%;
    justify-content: center;
  }

  .success-toast,
  .error-toast {
    top: 80px;
    right: 10px;
    left: 10px;
    font-size: 14px;
  }
}
</style>